export default __webpack_public_path__ + "static/media/arrow-right.54aca857.svg";